import { apiFetch } from './client';

export const listUsers = (token) => apiFetch(token, '/users');

export const createUser = (token, payload) =>
  apiFetch(token, '/users', { method: 'POST', body: JSON.stringify(payload) });

export const updateUser = (token, userId, payload) =>
  apiFetch(token, `/users/${userId}`, { method: 'PATCH', body: JSON.stringify(payload) });

export const updateUserRole = (token, userId, role) =>
  apiFetch(token, `/users/${userId}/role`, { method: 'PATCH', body: JSON.stringify({ role }) });

export const deleteUser = (token, userId) =>
  apiFetch(token, `/users/${userId}`, { method: 'DELETE' });
